import {useLocation, useNavigate} from 'react-router'
import {useMemo} from 'react'

function useSearchParams<T extends {[k: string]: string}>() {
    const location = useLocation()
    const navigate = useNavigate()

    // Parse the query string into a URLSearchParams object
    const searchParams = useMemo(() => {
        const urlSearchParams = new URLSearchParams(location.search)
        return Object.fromEntries(urlSearchParams.entries()) as Partial<T>
    }, [location.search])

    // Function to update the search parameters
    const setSearchParams = (newParams: Partial<T>) => {
        const params = new URLSearchParams(location.search)

        // Update or delete parameters based on the newParams object
        Object.entries(newParams).forEach(([key, value]) => {
            if (value === undefined || value === null) {
                params.delete(key)
            } else {
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                params.set(key, value)
            }
        })

        // Update the URL without reloading the page
        void navigate({search: params.toString()}, {replace: true})
    }

    return [searchParams, setSearchParams] as [Partial<T>, (newParams: Partial<T>) => void]
}

export default useSearchParams
